import Menu from './Menu';

export default Menu;


// WEBPACK FOOTER //
// ./app/components/Menu/index.js